import React from 'react';
import {makeStyles, withStyles} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import InputBase from "@material-ui/core/InputBase";

const BootstrapInput = withStyles((theme) => ({
    root: {
        marginTop: '0 !important',
        'label + &': {
            marginTop: theme.spacing(3),
            padding: 0,
        },
        '&.Mui-error input': {
            borderColor: '#7D1C24',
            '&:hover':{
                boxShadow: '0px 0px 0px 4px #F2B8B5',
            }
        }
    },
    input: {
        color: '#2F3337',
        borderRadius: '12px',
        position: 'relative',
        backgroundColor: '#FFF',
        border: '1px solid #E3E6E8',
        fontSize: '0.9rem',
        width: '100%',
        padding: '10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderColor: '#FFD799',
            backgroundColor: theme.palette.common.white,
        },
        '&:hover':{
            boxShadow: '0px 0px 0px 4px #FCEACE',
            borderColor: '#FFC160'
        }
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        width: '100%'
    },
    label: {
        color: '#758089 !important',
        fontSize: '0.9rem',
        fontWeight: 400,
        position: 'relative',
        lineHeight: '144%',
        transition: 'none',
        transform: 'none',
        marginBottom: '5px'
    }
}));

export const StyledTextarea: React.FC<Props> = ({id, label, onChange, value, rows, placeholder}) => {
    const classes = useStyles();

    return (
        <FormControl className={classes.margin}>
            <InputLabel shrink htmlFor={id} className={classes.label}>
                {label}
            </InputLabel>
            <BootstrapInput multiline rows={rows} id={id} onChange={onChange} value={value} placeholder={placeholder} />
        </FormControl>
    );
}

interface Props {
    id: string,
    label: string,
    onChange: any,
    value: any,
    rows: number,
    placeholder?: string
}
